var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.802734,
    width: 25.3519,
    height: 25.3504,
    rx: 12.6752,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_789_63290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 27
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_789_63290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21763 13.4785H6.80096L13.176 7.10352L19.551 13.4785H18.1343",
    stroke: "#FB8B00",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21765 13.4785V18.4368C8.21765 18.8126 8.36691 19.1729 8.63258 19.4386C8.89826 19.7043 9.25859 19.8535 9.63432 19.8535H16.7177C17.0934 19.8535 17.4537 19.7043 17.7194 19.4386C17.9851 19.1729 18.1343 18.8126 18.1343 18.4368V13.4785",
    stroke: "#FB8B00",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.051 19.8542V15.6042C11.051 15.2284 11.2002 14.8681 11.4659 14.6024C11.7316 14.3368 12.0919 14.1875 12.4676 14.1875H13.8843C14.26 14.1875 14.6204 14.3368 14.886 14.6024C15.1517 14.8681 15.301 15.2284 15.301 15.6042V19.8542",
    stroke: "#FB8B00",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePin);
export default __webpack_public_path__ + "static/media/home_pin.dc6243a530965f3ffb7a5187ea1a3300.svg";
export { ForwardRef as ReactComponent };